import { render, staticRenderFns } from "./icon-dollar-sign.vue?vue&type=template&id=64f06b4c&"
import script from "./icon-dollar-sign.vue?vue&type=script&lang=js&"
export * from "./icon-dollar-sign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports